export default __webpack_public_path__ + "static/media/pxgroup.0d2b603d.png";